import { render, staticRenderFns } from "./FavoriteDrivers.vue?vue&type=template&id=d0ff6e52&scoped=true&lang=pug"
import script from "./FavoriteDrivers.vue?vue&type=script&lang=js"
export * from "./FavoriteDrivers.vue?vue&type=script&lang=js"
import style0 from "./FavoriteDrivers.vue?vue&type=style&index=0&id=d0ff6e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ff6e52",
  null
  
)

export default component.exports